import { FeatureFlags, isFeatureEnabled } from "../config/featureFlags";
import type { Tenant } from "../types/Tenant";
import { UserRole } from "../types/User";
import { normalizeUserRole } from "./userRoles";

const PRODUCTION_DASHBOARD_HOSTNAMES = new Set([
    "dashboard.agenturphilipp.de",
    "dashboard-v2.agenturphilipp.de",
]);

const currentHostname = (): string =>
    typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();

export const isDialplanStagingOnlyFeatureEnabled = (hostname = currentHostname()): boolean =>
    !PRODUCTION_DASHBOARD_HOSTNAMES.has(hostname.toLowerCase())
    && isFeatureEnabled(FeatureFlags.STAGING_ONLY_DIALPLAN_LOGIC.key);

export const isDialplanBotEnabledForTenant = (tenant: Pick<Tenant, "showDialplanBot" | "hiddenPages"> | null | undefined): boolean => {
    return isDialplanStagingOnlyFeatureEnabled() && (
        tenant?.showDialplanBot === true || String(tenant?.showDialplanBot) === "true"
    );
};

export const canAccessDialplanBot = (
    role: unknown,
    tenant: Pick<Tenant, "showDialplanBot" | "hiddenPages"> | null | undefined
): boolean => {
    const normalizedRole = normalizeUserRole(role);
    const hasAllowedRole = normalizedRole === UserRole.ADMIN || normalizedRole === UserRole.SUPER_ADMIN;
    return hasAllowedRole && isDialplanBotEnabledForTenant(tenant);
};

export const canAccessDialplanOverview = (role: unknown): boolean => {
    const normalizedRole = normalizeUserRole(role);
    const hasAllowedRole = normalizedRole === UserRole.ADMIN || normalizedRole === UserRole.SUPER_ADMIN;
    return hasAllowedRole && isDialplanStagingOnlyFeatureEnabled();
};
